module.exports = __webpack_public_path__ + "img/kv1.a05cead8.png";